import { inject, InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { CarePlanAction } from '../actions.model';
import { CreateActionRequest, UpdateActionRequest } from './action-api.model';
import { MockActionApiService } from '../mock/mock-action-api.service';

export interface ActionPage {
  items: CarePlanAction[];
  consumedItems: number;
  pagination: {
    limit: number;
    offset: number;
    totalItems: number;
  };
}

export interface ActionApi {
  listActions(
    caseId: string,
    limit: number,
    offset: number,
  ): Observable<ActionPage>;
  listClientActions(
    clientId: number,
    statusCodes: readonly string[],
    limit: number,
    offset: number,
  ): Observable<ActionPage>;
  getAction(actionId: string): Observable<CarePlanAction>;
  createAction(body: CreateActionRequest): Observable<CarePlanAction>;
  updateAction(
    actionId: string,
    body: UpdateActionRequest,
  ): Observable<CarePlanAction>;
}

export const ACTION_API = new InjectionToken<ActionApi>('ACTION_API', {
  providedIn: 'root',
  factory: () => inject(MockActionApiService),
});
